import React from 'react'
import { connect } from 'react-redux'
// import { Link } from 'react-router-dom'
import { Spin } from 'antd'
import style from '../style.module.scss'

@connect(({ user }) => ({ user }))
class AcceptCollboratorInvitation extends React.Component {
  state = { isProcessing: true, afterProcessingMsg: '' }

  componentDidMount() {
    const { dispatch } = this.props
    dispatch({
      type: 'user/TEAM_COLLABORATOR_ACCEPT_INVITE',
      onComplete: this.hideLoader,
    })
  }

  hideLoader = ({ error, cancelled, data }) => {
    if (!error && !cancelled && data.data) {
      this.setState({
        isProcessing: false,
        afterProcessingMsg: 'You have successfully accepted your invitation.',
      })
    } else {
      this.setState({
        isProcessing: false,
        afterProcessingMsg: 'This invitation link has expired.',
      })
    }
  }

  render() {
    const { isProcessing, afterProcessingMsg } = this.state
    return (
      <div className={style.verifyEmailContainer}>
        {isProcessing && (
          <Spin
            tip={<h2>Please wait... we are processing your invitation...</h2>}
            size="large"
            className={style.verifyEmailLoader}
          />
        )}
        {!isProcessing && (
          <React.Fragment>
            <div className={style.verifyEmailLoader}>
              <h2>{afterProcessingMsg}</h2>
            </div>
          </React.Fragment>
        )}
      </div>
    )
  }
}

export default AcceptCollboratorInvitation
